<template>
  <vue-select
    ref="multiselect"
    v-model="valueData"
    :options="options"
    :label="label"
    @search="onSearch"
  >
    <template slot="option" slot-scope="option">
      {{ option[label] }}
    </template>
    <template slot="selected-option" slot-scope="option">
      {{ option[label] }}
    </template>
  </vue-select>
</template>

<script>
import VueSelect from 'vue-select';

export default {
  components: {
    'vue-select': VueSelect,
  },

  props: {
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'label',
    },
    defaultOptions: {
      type: Array,
      default: () => [],
    },
    searchFunction: {
      type: Function,
      default: () => {},
    },
    // eslint-disable-next-line
    value: {},
  },

  data() {
    return {
      options: [],
      valueData: null,
      searchQuery: '',
      searchRequestId: null,
    };
  },

  watch: {
    value: {
      handler(newVal) {
        this.valueData = newVal;
      },
      deep: true,
    },
    valueData: {
      handler() {
        this.$emit('input', this.valueData);
      },
      deep: true,
    },
    defaultOptions: {
      handler() {
        if (!this.searchQuery) {
          this.options = this.defaultOptions;
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.valueData = this.value;
    this.options = this.defaultOptions;
    this.$watch(() => this.$refs.multiselect.search, (val) => {
      this.searchQuery = val;
      if (!val) {
        this.options = this.defaultOptions;
        this.$refs.multiselect.toggleLoading(false);
      }
    });
  },

  methods: {
    onSearch(search, loading) {
      loading(true);
      this.searchRequestId = Math.random();
      this.searchFunction(loading, search, this, this.searchRequestId);
    },
    clearValues() {
      this.valueData = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// SelectRemote.vue?a9338c92